exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".prometheus-metric-type-selector-account-hint {\n  display: flex;\n  align-items: center;\n  height: 30px;\n}\n", ""]);

